import { UserCustomizations } from '../../store/UserCustomizations';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getUserCustomizations = () => {
  return apiService.callExternalApi<UserCustomizations>({
    url: `${API_SERVER_URL}/user-customizations`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const updateUserCustomizationData = (data: UserCustomizations) => {
  return apiService.callExternalApi<UserCustomizations>({
    url: `${API_SERVER_URL}/user-customizations`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify(data)
  });
};
